/**
 * The names in the `--text-*` namespace, as ONE list.
 *
 * tailwind-merge only knows the stock font sizes (`text-sm`, `text-lg`…). Anything else in the
 * `text-` namespace it classifies as a text *colour* — so `text-micro` is treated as conflicting
 * with `text-text-subtle`, and one of them is silently dropped. The symptom is not an error: it
 * is a badge rendering at 16px instead of 11px, or ink text on an ink button.
 *
 * This list therefore has to be registered with both tailwind-merge (cn.ts) and the tailwind-
 * variants instance (tv.ts), which run separate merge passes. It lived as two hand-copied arrays
 * and drifted the first time a token was added — `text-scale.test.ts` now fails the build when
 * this list and `theme.css` disagree.
 */
export const TEXT_SCALE = [
  'micro',
  'caption',
  'body',
  'ui',
  'lead',
  'title',
  'display',
  'hero',
] as const

/** Shape both twMerge and tailwind-variants expect for the `font-size` class group. */
export const FONT_SIZE_CLASS_GROUP = { 'font-size': [{ text: [...TEXT_SCALE] }] }
